import { setGradeApplication, setGrades } from "./gradeApplicationSlice";
import * as gradeApplicationService from "../../../services/GradeApplication";
import * as stakeholderService from "../../../services/Stakeholder";

export const fetchGradeApplication = stakehodlerId => async dispatch => {
    try {
        const gradeApp = await gradeApplicationService.getGradeApplicationByStakeholderId(stakehodlerId);
        const sortedGradeApp = gradeApp.data?.sort(function(a, b){return b.forGrade?.order-a.forGrade?.order});
        dispatch(setGradeApplication(sortedGradeApp));
    } catch (err) {
        throw err;
    }
};

export const fetchGrades = () => async(dispatch) => {
    try {
        const grades = await stakeholderService.getAllGrades();
        dispatch(setGrades(grades.data));
    } catch (error) {
        throw error;
    }
}


// gradeApplication.sort(function(a, b){return b.forGrade?.order-a.forGrade?.order});